var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 66C44.7842 66 52.2842 62.6421 57.7132 57.2132C63.1421 51.7842 66.5 44.2842 66.5 36C66.5 27.7158 63.1421 20.2158 57.7132 14.7868C52.2842 9.35787 44.7842 6 36.5 6C28.2158 6 20.7158 9.35787 15.2868 14.7868C9.85787 20.2158 6.5 27.7158 6.5 36C6.5 44.2842 9.85787 51.7842 15.2868 57.2132C20.7158 62.6421 28.2158 66 36.5 66Z",
    fill: "white",
    stroke: "#6d4096",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36L33.5 45L51.5 27",
    stroke: "#6d4096",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOne);
export default __webpack_public_path__ + "static/media/check-one.90a71effcafcae3803ae417ab796a39f.svg";
export { ForwardRef as ReactComponent };